import React from 'react'
import { Link } from 'react-router-dom'
import { Badge, Box, TableFooter, TableRow, TableCell } from '@mui/material'
import Pagination from '@/Components/Elements/Pagination'
import ItemCounter from '@/Components/Elements/ItemCounter'
import LoadingDefault from '@/Components/Elements/Loading/LoadingDefault'

interface DossierTableFooterProps {
    loadingContent: any
    results: any
    pager: any
    actionBtns: any[]
    kedo: any
    isCustomActionButton: (item: any) => boolean
    renderAggregateField: (item: any) => React.ReactNode
    onChangePage: (page: number) => void
}

const DefDossierListTableFooter: React.FC<DossierTableFooterProps> = ({
    loadingContent,
    results,
    pager,
    actionBtns,
    kedo,
    isCustomActionButton,
    renderAggregateField,
    onChangePage,
}) => {
    if (!results || !results.dossiers || results.dossiers.length <= 0)
        return null

    const listItems = results.items.filter(
        (item: any) => item.view === 'list' && !isCustomActionButton(item)
    )

    const extraColumns = actionBtns.length > 0 ? 4 : 3
    if (loadingContent) {
        return (
            <TableFooter>
                <TableRow>
                    <TableCell
                        colSpan={listItems.length + extraColumns}
                        sx={{ textAlign: 'center' }}
                    >
                        <LoadingDefault />
                    </TableCell>
                </TableRow>
            </TableFooter>
        )
    }
    return (
        <TableFooter>
            <TableRow className="tr-aggr">
                <TableCell sx={{ width: '3%' }} />
                <TableCell sx={{ textAlign: 'center' }} />
                {listItems.map((listItem, lIndex) => (
                    <TableCell key={lIndex}>
                        {renderAggregateField(listItem)}

                        {/* Link badges */}
                        {listItem?.def_dossier_link &&
                            results?.aggregations?.[listItem.id] && (
                                <div className="aggr-result">
                                    {results.aggregations?.[listItem.id].map(
                                        (aggrItem: any, aggrIndex: number) => (
                                            <Badge
                                                key={aggrIndex}
                                                sx={{ mr: 1 }}
                                            >
                                                <Link
                                                    to={`/contentdossier/${aggrItem.id}`}
                                                >
                                                    {aggrItem.summary}
                                                </Link>{' '}
                                                <Box component="span">
                                                    {aggrItem.total}
                                                </Box>
                                            </Badge>
                                        )
                                    )}
                                </div>
                            )}

                        {/* Field aggregation based on type */}
                        {listItem?.def_dossier_def_field &&
                            results?.aggregations?.[listItem.id] && (
                                <div className="aggr-result">
                                    {/* Date type */}
                                    {listItem.def_dossier_def_field.def_field
                                        .type === 'date' &&
                                        kedo
                                            .utils()
                                            .dateFormat(
                                                results.aggregations[
                                                    listItem.id
                                                ]
                                            )}

                                    {/* Time / amount type */}
                                    {(listItem.def_dossier_def_field.def_field
                                        .type === 'time' ||
                                        listItem.def_dossier_def_field.def_field
                                            .type === 'amount') &&
                                        results.aggregations[listItem.id]}

                                    {/* List type */}
                                    {listItem.def_dossier_def_field.def_field
                                        .type === 'list' &&
                                        listItem.def_dossier_def_field.def_field.def_field_lists
                                            .filter((defFieldListItem: any) =>
                                                results.aggregations[
                                                    listItem.id
                                                ].find(
                                                    (selItem: any) =>
                                                        selItem.id ===
                                                        defFieldListItem.id
                                                )
                                            )
                                            .map(
                                                (
                                                    defFieldListItem: any,
                                                    dIndex: number
                                                ) => (
                                                    <Badge
                                                        key={dIndex}
                                                        className="mr-1"
                                                        style={{
                                                            backgroundColor:
                                                                defFieldListItem.color ||
                                                                undefined,
                                                        }}
                                                    >
                                                        {kedo.translateItem(
                                                            defFieldListItem,
                                                            'def_field_list'
                                                        )}{' '}
                                                        <span className="badge badge-light">
                                                            {
                                                                results.aggregations[
                                                                    listItem.id
                                                                ].find(
                                                                    (
                                                                        selItem: any
                                                                    ) =>
                                                                        selItem.id ===
                                                                        defFieldListItem.id
                                                                ).total
                                                            }
                                                        </span>
                                                    </Badge>
                                                )
                                            )}
                                </div>
                            )}
                    </TableCell>
                ))}
                <TableCell colSpan={extraColumns - 2} />
            </TableRow>

            <TableRow>
                <TableCell colSpan={results.items.length + extraColumns}>
                    <Pagination pager={pager} onChangePage={onChangePage} />
                    <ItemCounter pager={pager} />
                </TableCell>
            </TableRow>
        </TableFooter>
    )
}

export default DefDossierListTableFooter
